import { createContext } from 'react';

// True when Clerk never loaded in Electron (offline) and we fell back to the
// embedded server's localhost trust. OrgGuard reads this to skip the org check
// for returning users whose org the server already restored from disk.
export const ClerkBypassCtx = createContext(false);
